export const AUDIO_ERROR_TEXTS = {
    SOMETHING_WENT_WRONG: "Something went wrong",
    FAILED_TO_PLAY_AUDIO: "Failed to play audio",
    PLAYBACK_FAILED: "Playback failed",
    FAILED_TO_RESUME_AUDIO: "Failed to resume audio",
};
